import { Injectable } from "@angular/core";

export const KEYS = {
  IsFirestFreeSendMsgChatRoom: "send-msg",
  MeID: "axes-me",
  CreatedAt: "created_at",
  DailyBonus: "daily-bonus",
  DailySwipe: "daily-swipe",
  TemporalSearchUserImpression: "temporal_search_user_impression",
  AllSearchUserImpression: "all_search_user_impression",
  MessageFromLikeModalShown: "message_from_like_modal_shown",
  DialogFlag: "dialog_flag",
  SecretModeFlag: "secret_mode_flag",
  HideListLength: "hide_list_length",
  BlockListLength: "block_list_length",
  WarningBannerAlertShown: "warning_banner_alert_shown",
  EditProfileButtonSpotlightShown: "edit_profile_button_spotlight_shown",
  MeetingSpotlightShown: "meeting_spotlight_shown",
  TransactionIDTj: "transaction_id_tj",
  WebTrackToken: "pv-web-track",
  ChatCoachingShown: "chat_coaching_shown",
  TutorialLikeList: "tutorial_like_list",
  ChanceTime: "chance-time",
  SearchLength: "search_length",
  TutorialPremiumShown: "tutorial_premium_shown",
  ShowReplyLikeModal: "show_reply_like_modal",
  RichMaleSwipe: "rich_male_swipe",
  MoveTo: "move_to",
  UserProfileRoyalSpotlightShown: "user_profile_royal_spotlight_shown",
  UserProfileBoardSpotlightShown: "user_profile_board_spotlight_shown",
  DailyRoyalPickup: "daily_royal_pickup",
  DatedSurveyModal: "dated_survey_modal",
  QualityCheckHistory: "quality_check_history",
  SearchParamsList: "search_params_list",
  TodayChocolateNum: "today_chocolate_num",
  DailyChocolate: "daily_chocolate",
  ShowChocolateCoaching: "show_chocolate_coaching",
  AppointmentReminding: "appointment_reminding",
  ShowChatToolsCoaching: "show_chat_tools_coaching",
  ShowAttachedNameSpotLight: "show_attached_name_spotlight",
  ShowNoteAndAppointmentSpotLight: "show_note_and_appointment_spotlight",
  FirstRichLikeConfirmShown: "first_rich_like_confirm_shown",
  TutorialLikeUsers: "tutorial_like_users",
  DisplayedBoardSpotlight: "displayed_board_spotlight",
};

@Injectable()
export class LocalstorageProvider {
  constructor() {}

  setValue(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  getValue(key: string): string {
    return localStorage.getItem(key);
  }

  removeValue(key: string): void {
    localStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// ./src/providers/localstorage/localstorage.ts